import { IDME_COUPONS, type UserGroup } from '@pff-consumer/schema'
import type { CheckoutState } from '../checkout.slice'

interface FunctionArgs {
  state: CheckoutState
  userGroup: UserGroup
  idmeId: string | null
}

export const updatePromoCodeAndIdmeId = (args: FunctionArgs) => {
  const { state, userGroup, idmeId } = args

  if (userGroup && IDME_COUPONS[userGroup]) {
    state.promoCode = IDME_COUPONS[userGroup]
  }

  if (idmeId) {
    state.idmeId = idmeId
  }
}
